import { BookText, CalendarDays } from "lucide-react";
import React from "react";
import { Link, NavLink } from "react-router-dom";
// css comes in published_file.css

const CompletBoxHW = (props) => {
  const reduceParaGraph = (text, length) => {
    if (text.length < length) {
      return text;
    }
    return text.substring(0, length) + "...";
  };
  return (
    <>
      <div
        className="w-100 h-100 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4"
        style={{
          backgroundColor: "#FDEFE3",
          borderTop: "2px solid #8D4B28",
          borderRight: "4px solid #8D4B28",
          borderBottom: "1px solid #8D4B28",
          borderLeft: "1px solid #8D4B28",
          borderRadius: "0.75rem",
        }}
      >
        {/* Header: Class | Section | Subject + 3 Dots */}
        <div className="d-flex justify-content-between align-items-start mb-2">
          <NavLink
            state={{ homework_id: props.id }}
            to={`/CompleteStudentListHW`}
            className="text-dark fw-semibold text-decoration-none"
          >
            {props?.standard} – {props?.section} |{" "}
            <span title={props?.Complet_subject} className="poppins-semibold">
              {reduceParaGraph(props?.Complet_subject, 27)}
            </span>
          </NavLink>
        </div>

        {/* Assessment Name */}
        <NavLink
          state={{ homework_id: props.id }}
          to="/CompleteStudentListHW"
          className="text-decoration-none text-dark"
        >
          <div className="d-flex align-items-center mb-1">
            <BookText size={16} className="me-2 text-dark" />
            <div className="text-truncate poppins-semibold">
              {props.Complet_assessName}
            </div>
          </div>

          {/* Deadline */}
          <div
            className="d-flex align-items-center text-muted"
            style={{ fontSize: "0.875rem" }}
          >
            <CalendarDays size={16} className="me-2 text-dark" />
            <span>
              <span className="me-1">Evaluated On :</span>
              <span className=" text-dark">{props.deadline}</span>
            </span>
          </div>
        </NavLink>
      </div>
    </>
  );
};

export default CompletBoxHW;
